// File: frontend/src/utils/imageProcessor.js

export const processUpload = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const { width, height } = img;
                
                // --- CONFIGURATION ---
                const PREVIEW_MAX = 800;  // Speed: Fast for screen
                const EXPORT_MAX = 2500;  // Quality: High for Download

                // 1. Generate FAST Preview (What user sees)
                const previewBlob = resizeImageCanvas(img, width, height, PREVIEW_MAX);
                
                // 2. Generate HIGH-RES Master (What user downloads)
                // We prepare this immediately so download is instant later
                const masterBlob = width > EXPORT_MAX || height > EXPORT_MAX 
                    ? resizeImageCanvas(img, width, height, EXPORT_MAX)
                    : event.target.result;

                resolve({
                    previewUrl: previewBlob,
                    masterUrl: masterBlob,
                    originalWidth: width,
                    originalHeight: height,
                    aspectRatio: width / height
                });
            };
            img.onerror = reject;
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    });
};

const resizeImageCanvas = (img, w, h, maxDim) => {
    let newW = w;
    let newH = h;

    // Calculate new size maintaining aspect ratio
    if (w > h) {
        if (w > maxDim) {
            newH = Math.round(h * (maxDim / w));
            newW = maxDim;
        }
    } else {
        if (h > maxDim) {
            newW = Math.round(w * (maxDim / h));
            newH = maxDim;
        }
    }

    const canvas = document.createElement('canvas');
    canvas.width = newW;
    canvas.height = newH;
    const ctx = canvas.getContext('2d');
    
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, newW, newH);
    
    // Return high-quality JPEG for speed/compatibility
    return canvas.toDataURL('image/jpeg', 0.95);
};